export function menuTemplateModel(data) {
    const { id, name, business_id } = data || {};
    return {
        id: id || "",
        name: name || "",
        business_id: business_id || "",
    }
}
